<template>

    <div class="profile-setting-page">
        <h1>{{ $t('profile_settings') }} </h1>
        <div class="forms-style-1">
            <div class="row">
                <div class="col-md-12 col-sm-12">
                    <div class="row">
                        <div class="col-md-6 col-sm-6">
                            <div class="input-row">
                                <label>{{ $t('name') }}:</label>

                                <input type="text" placeholder="change your name" v-model="users.original.name"/>

                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6">
                            <div class="input-row">
                                <label>{{ $t('email') }}</label>
                                <span class="useremail">{{users.original.email}}</span>
                            </div>
                        </div>
                        <div class="col-md-6 col-sm-6">
                            <div class="input-row">
                                <label></label>
                                <button class="change-pwd">{{ $t('change_password') }} </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="profile-btn">
            <button class="updatebtn">{{ $t('update') }}</button>
        </div>
    </div>


    <div class="popup-row" id="cancel-profile">
        <div class="popup-Comment-row">
            <p>{{ $t('discard_changes') }} </p>
            <span>{{ $t('you_have_unsaved') }}</span>
            <div class="popup-Comment-btn">
                <button class="profile-cancel">{{ $t('cap_cancel') }}</button>
                <button>{{ $t('cap_yes_discard') }}</button>
            </div>
        </div>
    </div>





</template>

<script>


export default
{
    name: "ProfileSettingsPage",
    components: {},
    props: {
        users:{
            type:Object,
            default:[]
        }
    },

    data() {
        return {}
    }
}
</script>

<style scoped>

</style>
